import React, { PropTypes } from "react";
import classNames from "classnames";
import { bindActionCreators } from "redux";
import * as clientActions from "../dashboard/clients/client/clientActions";
import { connect } from "react-redux";
import userHasAccess from "../../utils/userHasAccess";
import { HR_CLERK, INFORMATION_AGENT, PLAN_ADMINISTRATOR } from "../../utils/Roles";

class HistoryNavigator extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    componentWillUpdate(nextProps) {
        const isExternalUser = userHasAccess([PLAN_ADMINISTRATOR, INFORMATION_AGENT, HR_CLERK], true);
        if (this.props.currentClient && nextProps.currentClient && isExternalUser) {
            if (this.props.currentClient.clientId !== nextProps.currentClient.clientId) {
                this.props.clientActions.setClientSelectorClient({
                    id: nextProps.currentClient.clientId,
                    name: nextProps.currentClient.name,
                });
            }
        }
    }

    render() {
        const backClassNames = classNames({
            back: true,
            icon: true,
            "icon-chevron-small-left": true,
        });
        const setForwardClassNames = classNames({
            forward: true,
            icon: true,
            "icon-chevron-small-right": true,
        });

        return (
            <div className="history-navigator">
                <div
                    className={backClassNames}
                    onClick={() => {
                        this.context.router.goBack();
                    }}
                />
                <div
                    className={setForwardClassNames}
                    onClick={() => {
                        this.context.router.goForward();
                    }}
                />
            </div>
        );
    }
}

HistoryNavigator.contextTypes = {
    router: PropTypes.object,
};

HistoryNavigator.propTypes = {
    clientActions: PropTypes.object,
    currentClient: PropTypes.object,
};

function mapStateToProps(state) {
    return {
        currentClient: state.data && state.data.clients && state.data.clients.active,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        clientActions: bindActionCreators(clientActions, dispatch),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(HistoryNavigator);



// WEBPACK FOOTER //
// ./src/components/common/HistoryNavigator.js